import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import config from './config';

// eslint-disable-next-line import/no-mutable-exports
let awsRum: AwsRum | null = null;

if (window.location.hostname !== 'live.cogneed.ai') {
  try {
    const awsRumConfig: AwsRumConfig = {
      sessionSampleRate: 1,
      guestRoleArn: config.AwsRum.GuestRoleArn,
      identityPoolId: config.Cognito.IdentityPoolId,
      endpoint: config.AwsRum.Endpoint,
      sessionEventLimit: Infinity,
      telemetries: [
        ['errors', { stackTraceLength: 500 }],
        'performance',
        ['http', { stackTraceLength: 500, addXRayTraceIdHeader: true }],
      ],
      allowCookies: true,
      enableXRay: true,

      cookieAttributes: {
        domain: config.Auth.Cookies.CookieDomain,
        path: '/',
        sameSite: 'Strict',
        secure: true,
      },
      enableRumClient: true,
      pageIdFormat: 'HASH',
    };

    awsRum = new AwsRum(
      config.AwsRum.AppId,
      config.AppVersion,
      'eu-west-3',
      awsRumConfig,
    );
  } catch (error) {
    console.error(error);
  }
}

export default awsRum;
